import type { AxiosInstance, CreateAxiosDefaults } from 'axios';
import { defaultHeaders, errorLogger } from './helpers';
import { tokenInterceptor } from './interceptors/request';
import { responderInterceptor } from './interceptors/response';
import type { TAxiosResponseInterceptorError } from './types';

export const defaultAxiosParams: CreateAxiosDefaults = {
  headers: defaultHeaders,
  responseType: 'json',
};

export const bindInterceptors = (
  axios: AxiosInstance,
  handleResponseInterceptorError?: TAxiosResponseInterceptorError
) => {
  axios.interceptors.request.use(tokenInterceptor, errorLogger);

  axios.interceptors.response.use(
    responderInterceptor,
    handleResponseInterceptorError
  );
};

export const bindWssInterceptors = (
  axios: AxiosInstance,
  handleResponseInterceptorError?: TAxiosResponseInterceptorError
) => {
  axios.interceptors.request.use(tokenInterceptor, errorLogger);

  axios.interceptors.response.use(res => res, handleResponseInterceptorError);
};
